// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING, MAX_SIZE_FILE_UPLOAD } from '~/utils/constants/common';
import { IFormMaterial } from '~/utils/interface/material';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      materialImage: yup
        .object()
        .shape({
          id: yup.string().trim().optional(),
          url: yup.string().trim().optional(),
          file: yup
            .mixed<File>()
            .optional()
            .test('fileSize', t('common_validate_file_size', { ns: 'common/base' }), (value) => {
              if (!value) return true;
              if (value && value?.size <= MAX_SIZE_FILE_UPLOAD) return true;
              return false;
            }),
        })
        .optional(),
      name: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      price: yup.string().trim().optional(),
      unit: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      quantity: yup.string().trim().optional(),
      description: yup.string().trim().optional(),
      partNumber: yup.string().trim().optional(),
      cost: yup.string().trim().optional(),
      categoryId: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      isTaxable: yup.boolean().optional(),
      isPriceBook: yup.boolean().optional(),
      businessPriceBook: yup.string().trim().optional(),
      businessPriceBookType: yup.string().trim().optional(),
      total: yup.string().trim().optional(),
      isUnSavePriceBook: yup.boolean().optional(),
    })
    .required();
};

export const defaultValuesForm: IFormMaterial = {
  materialImage: {},
  name: EMPTY_STRING,
  description: EMPTY_STRING,
  price: EMPTY_STRING,
  quantity: EMPTY_STRING,
  unit: EMPTY_STRING,
  partNumber: EMPTY_STRING,
  isPriceBook: false,
  isTaxable: false,
  cost: EMPTY_STRING,
  categoryId: EMPTY_STRING,
};
